import { IsFreezingArrangementParams } from './catalogView.types';
import { getIsFreezeToManual } from './getIsFreezeToManual';
import { isMaterializeGrouping } from './isMaterializeGrouping';

export const isFreezingArrangement = ({
  configSnapshot,
  dirtyForAll,
  draft,
}: IsFreezingArrangementParams): boolean => {
  if (!draft || !configSnapshot) {
    return false;
  }

  return (
    getIsFreezeToManual({ configSnapshot, dirtyForAll, draft }) ||
    isMaterializeGrouping({ configSnapshot, dirtyForAll, draft })
  );
};
